import React from 'react';

import AbstractCmsElement from 'components/cms/elements/AbstractCmsElement';

export default class CmsElementNavigationChild extends AbstractCmsElement {
  onClick = e => {
    // prevent navigating away while editing, let the click bubble up to open the parent's settings instead
    e.preventDefault();
  };

  render() {
    const icon = this.getParamValue('icon', '');
    const title = this.getParamValue('title', '');

    return title || icon ? (
      <li id={this.getMainId()} className="ms-navigation-child">
        {this.getElementStyle()}

        <a href="#navigation-child" className="ms-navigation-child-link" onClick={this.onClick}>
          {icon ? <i className={'fa ' + icon + ' m-r-5'} /> : null}
          {title}
        </a>
      </li>
    ) : (
      <li className="padding-10 text-center">
        <i className="fa fa-link fa-2x" />
      </li>
    );
  }
}
CmsElementNavigationChild.defaultProps = {
  index: '0',
};
